export default __webpack_public_path__ + "static/media/signinlogo.44a822af.png";